import { defineMessages } from 'react-intl';

export default defineMessages({
    policyInformation: {
        id: 'quoteandbind.farm.views.policy-info.Policy Info',
        defaultMessage: 'Policy Information'
    }, 
    policySummary: {
        id: 'quoteandbind.farm.views.policy-summary.Policy Summary',
        defaultMessage: 'Policy Information'
    },
    coverageStartDate: {
        id: 'quoteandbind.farm.views.policy-info.Coverage Start Date',
        defaultMessage: 'Coverage Start Date'
    },
    primaryInsured: {
        id: 'quoteandbind.farm.views.policy-info.Primary Insured',
        defaultMessage: 'Primary Insured'
    },
    address: {
        id: 'quoteandbind.farm.views.policy-info.Address',
        defaultMessage: 'Address'
    },
    sameBillingAddress: {
        id: 'quoteandbind.farm.views.policy-info.Is the Billing Address the same as the above address?',
        defaultMessage: 'Is the Billing Address the same as the above address?'
    },
    email: {
        id: 'quoteandbind.farm.views.policy-info.Email',
        defaultMessage: 'Email'
    },
    phone: {
        id: 'quoteandbind.farm.views.policy-info.Phone',
        defaultMessage: 'Phone'
    },
    coverages: {
        id: 'quoteandbind.farm.views.policy-info.Your Coverages',
        defaultMessage: 'Coverages'
    },
    details: {
        id: 'quoteandbind.farm.views.policy-info.Details',
        defaultMessage: 'Details'
    },
    completeAndIssue: {
        id: 'quoteandbind.farm.views.policy-info.Complete and Issue',
        defaultMessage: 'Complete and Issue'
    },
     downloadHOQuoteSummary:{
        id: 'quoteandbind.farm.policy-info.Download Quote Summary',
        defaultMessage: 'Download Quote Summary'
    },
    farmDocumentGenerationInProgress:{
       id: 'quoteandbind.farm.policy-info.Document Generation Is In Progress',
       defaultMessage: 'Document Generation Is In Progress'
    },
    farmDocumentGenerationInProgressConf:{
       id: 'quoteandbind.farm.policy-info.Document Generation Is In Progress. Please Try After Sometime.',
       defaultMessage: 'Document Generation Is In Progress. Please Try After Sometime.'
    },
    farmDocumentGenerationError:{
       id: 'quoteandbind.farm.policy-info.Unable to get quote document',
       defaultMessage: 'Unable to get quote document'
    },
    farmDocumentGenerationErrorConf:{
       id: 'quoteandbind.farm.policy-info.Problem occured while getting quote document. Please try again later',
       defaultMessage: 'Problem occured while getting quote document. Please try again later'
    },
    
});
